import ExcelJS from "exceljs";
import moment from "moment-timezone";
import { ExcelServicesBase } from "../../../backend/src/common/excel/excelServicesBase";
const XLSX = require("xlsx");

export default class ExcelServices extends ExcelServicesBase {
    async exportAccountingTable(tableInput, periods, tags, companyName: string) {
        // check
        if (!tableInput || !periods || !companyName) {
            debugger;
            return;
        }

        // create workbook
        const workbook = new ExcelJS.Workbook();

        // create worksheet
        const table = JSON.parse(JSON.stringify(tableInput)); // to not alter the prop
        const worksheetTitle = (table.name || "Comptes comptables").slice(0, 31); // 31 chars max in xls file
        ExcelServicesBase.createWorksheet(
            workbook,
            worksheetTitle,
            table,
            periods,
            tags,
            "standard",
        );

        // download file
        try {
            let title = `${companyName} - XLSX - ${worksheetTitle}`;
            if (periods?.length) {
                const endPeriod = periods[0].end.split("-").reverse().join("_");
                title += ` - Comptes annuels au ${endPeriod}`;
            }
            this.export(workbook, title);
            // const buffer = await workbook.xlsx.writeBuffer()
            // const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            // const url = URL.createObjectURL(blob)
            // const a = document.createElement('a')
            // a.href = url

            // a.download = title
            // a.click();
            // URL.revokeObjectURL(url)
            // console.log('File saved!')
        } catch (error) {
            debugger;
            console.error("Error saving file: ", error);
        }
    }

    async copyToClipboardAccountingTable(tableInput, periods, tags, companyName: string) {
        // check
        if (!tableInput || !periods || !companyName) {
            debugger;
            return;
        }

        // create workbook
        const workbook = new ExcelJS.Workbook();

        // create worksheet
        const table = JSON.parse(JSON.stringify(tableInput)); // to not alter the prop
        const worksheetTitle = (table.name || "Comptes comptables").slice(0, 31); // 31 chars max in xls file
        ExcelServicesBase.createWorksheet(
            workbook,
            worksheetTitle,
            table,
            periods,
            tags,
            "standard",
        );

        // copy to clipboard
        const worksheet = workbook.getWorksheet(1);
        let text = "";
        // iterate over each row in the worksheet
        worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
            // iterate over each cell of the row
            row.eachCell({ includeEmpty: false }, (cell, colNumber) => {
                text += cell.text || cell.value; // add the cell content to the text
                text += "\t"; // add a tab between in each cell
            });
            text = text.trim(); // remove the last tab
            text += "\n"; // add a newline at the end of each row
        });
        text = text.trim(); // remove the last line
        await navigator.clipboard.writeText(text); // copy the text to the clipboard
    }

    async export(workbook, title) {
        try {
            const buffer = await workbook.xlsx.writeBuffer();
            const filename = title + ".xlsx";
            const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const link = document.createElement("a");
            link.setAttribute("style", "display:none");
            const url = URL.createObjectURL(blob);
            link.href = url;
            link.download = filename;
            link.click();
            URL.revokeObjectURL(url);
            // console.log('File saved!')
        } catch (error) {
            debugger;
            console.error("Error saving file: ", error);
        }
    }

    /*
     *  Read .xlsx and return a csv format
     */
    static async xlsx2csv(file) {
        const data = await file.arrayBuffer();
        return ExcelServices.xlsx2csvFromArrayBuffer(data);
    }

    static xlsx2csvFromArrayBuffer(data) {
        let workbook = XLSX.read(data, { dateNF: "DD/MM/YYYY" });

        let sheetObject = [];

        // Pour une seule feuille pour l'instant
        let XL_row_object = XLSX.utils.sheet_to_csv(workbook.Sheets[workbook.SheetNames[0]]);
        if (XL_row_object.length && XL_row_object.replace(/ |\n/gi, "") !== "") {
            sheetObject = XL_row_object;
        }
        // workbook.SheetNames.forEach(function(sheetName) {
        //     let XL_row_object = XLSX.utils.sheet_to_csv(workbook.Sheets[sheetName]);
        //     if(XL_row_object.length && XL_row_object.replace(/ |\n/ig,"") !== ""){
        //         sheetObject = XL_row_object;
        //     }
        // })
        return sheetObject;
    }

    /*
     *  Read .xlsx, returns a json object
     */
    static async xlsx2json(file) {
        const data = await file.arrayBuffer();
        let workbook = XLSX.read(data, { dateNF: "DD/MM/YYYY" });

        let sheetObject = [];

        // Pour une seule feuille pour l'instant

        workbook.SheetNames.forEach(function (sheetName) {
            let XL_row_object = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
            if (XL_row_object.length) {
                sheetObject = [...XL_row_object];
            }
        });

        // transforms numbers and dates into valid string values
        return sheetObject;

        // transforms numbers and dates into valid string values
        // return this.json2table(sheetObject);
    }

    static json2table(sheetObject) {
        const self = this;
        let datas = [];
        let headers = [];
        if (sheetObject.length) {
            sheetObject.forEach(function (row) {
                for (let prop in row) {
                    if (!headers.includes(prop)) headers.push(prop);
                }
            });

            sheetObject.forEach(function (line) {
                let lineArray = [];
                headers.forEach(function (property) {
                    let value = line[property];

                    if (
                        property.includes("date") ||
                        property.includes("Date") ||
                        property.includes("DATE")
                    ) {
                        value = self.excelDateToJSDate(value);
                        line[property] = value;
                    }

                    if (value) {
                        if (typeof value === "string") {
                            lineArray.push(value);
                        } else {
                            lineArray.push(value.toString());
                            line[property] = value.toString();
                        }
                    } else {
                        lineArray.push("");
                        line[property] = "";
                    }
                });
                datas.push(lineArray);
            });
        }
    }

    /*
     *  transforme toutes les propriétés en string
     *  et transforme la date dans un format acceptable
     */

    static jsonStringify(sheetObject) {
        const self = this;
        let headers = [];
        if (sheetObject.length) {
            sheetObject.forEach(function (row) {
                for (let prop in row) {
                    if (!headers.includes(prop)) {
                        headers.push(prop);
                    }
                }
            });
            sheetObject.forEach(function (row) {
                headers.forEach(function (prop) {
                    let value = row[prop];

                    if (prop.includes("date") || prop.includes("Date") || prop.includes("DATE")) {
                        value = self.excelDateToJSDate(value);
                        row[prop] = value;
                    }

                    if (value) {
                        if (typeof value !== "string") {
                            row[prop] = row[prop].toString();
                        }
                    } else {
                        row[prop] = "";
                    }
                });
            });
        }
    }

    static excelDateToJSDate(excelDate) {
        if (excelDate) {
            let date = new Date(Math.floor((excelDate - 25569) * 86400 * 1000));
            let converted_date = date.toISOString().split("T")[0];
            let final_date = moment(converted_date, "YYYY-MM-DD").format("DD/MM/YYYY");
            return final_date;
        }
        return "";
    }
}
